import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthGuard } from '../../../shared/auth/auth.guard';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { AppsService } from '../../../shared/app.service';
import { Subscription } from 'rxjs';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { ComponentService } from '../../../shared/abstract/component.service';

@Component({
  selector: 'app-page-application',
  templateUrl: './page-application.component.html',
  styleUrl: './page-application.component.scss'
})
export class PageApplicationComponent extends ComponentService<any> implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild('rightSidebar') rightSidenav!: MatSidenav;
  sidenavOpen: boolean = false;
  @Input() isSidenavOpened: boolean = false; // Handle sidenav state
  @ViewChild(SidemenuComponent) sidemenu!: SidemenuComponent;  // Access the SidemenuComponent
  @Input({ required: true }) isLoaded!: any;

  public mobileQuery: MediaQueryList;
  public isShowSidebar: boolean;
  public sidebarOpened: boolean = true; // or false, depending on default state
  private mobileQueryListener: () => void;
  constructor(
    injector: Injector,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public jwtHelper: JwtHelperService,
    private _authGuard: AuthGuard,
    public overlayContainer: OverlayContainer,
    private _auth: AuthService,
    private router: Router) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);

    this.isShowSidebar = !this.mobileQuery.matches;
  }

  ngOnInit(): void {
    //this._appsService.getUserInfoRequest().then((res) => {
    
    //});
    this._appsService.isSidenavOpenedSubscription.subscribe(res => {
      if(res != null || res != undefined)
      this.isSidenavOpened = res

    })
  }

  onSideMenuStateChange(isOpened: boolean) {
    this.isSidenavOpened = isOpened;
  }

  toggleSidenav() {
    
    this.isSidenavOpened = !this.isSidenavOpened;

    this.isSidenavOpened ? this.sidemenu.directIncrease() : this.sidemenu.directDecrease();


  }
}
